import { MenuItem, TextField } from "@mui/material";

const SelectComponent = (props) => {
  const { question, multiline, disabled } = props;
  return (
    <>
      <TextField
        id={question._id}
        key={"component" + question._id}
        fullWidth={true}
        disabled={disabled}
        placeholder={question.tooltip ? question.questiond.tooltip : ""}
        onChange={(event) => {}}
        variant="outlined"
        select
      >
        {question.answers.map((ans, index) => (
          <MenuItem key={ans.value} value={ans.value}>
            {ans.text}
          </MenuItem>
        ))}
      </TextField>
      {question?.questiond?.helpPage !== undefined && (
        <a href="#">
          <div style={{ width: "100%", textAlign: "right" }}>
            {question.helpText}
          </div>
        </a>
      )}
    </>
  );
};
export default SelectComponent;
